



































































































import Vue from "vue";
import FactBtn from "../Utilities/FactBtn.vue";

export default Vue.extend({
  name: "ProjectStatusDetails",
  data: () => ({
    modalVisible: false as boolean
  }),
  components: {
    FactBtn
  },
  methods: {
    openModal() {
      this.modalVisible = !this.modalVisible;
    }
  }
});
